<template>
  <div id='index'>
       <div class="topcon">
             <div class="topcon-headimg" v-if="uinfo.headimg">
               <img :src="uinfo.headimg" v-if="uinfo.headimg"/>
             </div>
             <div class='topcon-user-group'>
                <div class="topcon-user-name">{{uinfo.username}}</div>
                <div class="topcon-user-level">{{uinfo.levelname}}</div>
             </div> 
             <div class='topcon-right'>
                <div class='topcon-right-share' @click="popShareSheet"><Icon src="share2" /></div>
                <div class='topcon-right-notify'><Icon src="notify2" /></div>
             </div>
        </div>
        <div class="maincon">
             <div class="maincon-swipelist">
               <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                  <van-swipe-item v-for='item in lunbolist' :key='item.id'>
                      <img class="maincon-swipe-img" :src="item.headimg" @click="goPage(item.link)"/>
                  </van-swipe-item>
               </van-swipe>
             </div>
             <div class="maincon-btngroup">
                <div class="maincon-btngroup-title">操作中心</div>
                <div class="maincon-btngroup-con">
                     <div class="maincon-btnitem" @click='goPage("/goodslist")'>
                           <div class="maincon-btnitem-img"><Icon src="gwc" class='iconstyle'/></div>
                           <div class="maincon-btnitem-text">订货</div>
                     </div>
                     <div class="maincon-btnitem" @click="goPage('/fahuo')">
                        <div class="maincon-btnitem-img"><Icon src="fahuo" class='iconstyle'/></div>
                        <div class="maincon-btnitem-text">发货</div>
                     </div>
                     <div class="maincon-btnitem" >
                        <div class="maincon-btnitem-img" @click="goPage('/myclient')"><Icon src="kwgl" class='iconstyle'/></div>
                        <div class="maincon-btnitem-text">客户管理</div>
                     </div>
                     <div class="maincon-btnitem"  @click='goPage("/orderlist")'>
                        <div class="maincon-btnitem-img"><Icon src="orderlist" class='iconstyle'/></div>
                        <div class="maincon-btnitem-text">订单信息</div>
                     </div>
                </div>
             </div>
             <div class="windowgroup" v-if="iswindowsshowed">
                 <div class="part1">
                     <img :src="windowshow[0].headimg" @click="goPage(windowshow[0].link)"/>
                 </div>
                 <div class="part2">
                     <div class="part2-left">
                        <img :src="windowshow[1].headimg" @click="goPage(windowshow[1].link)"/>
                     </div>
                     <div class="part2-right">
                           <div class="part2-right-top">
                              <img :src="windowshow[2].headimg" @click="goPage(windowshow[2].link)"/>
                           </div>
                           <div class="part2-right-bottom">
                              <img :src="windowshow[3].headimg" @click="goPage(windowshow[3].link)"/>
                           </div>
                     </div>
                 </div>
             </div>
             <div class="actcon">
                 <div class="actcon-title">活动中心</div>
                 <div class="actcon-list">
                     <div class="actcon-list-item-row" v-for="item in activities" :key="item.id" @click="goPage(item.link)">
                         <div class="actcon-list-item-col"><img :src="item.headimg"/></div>
                         <div class="actcon-list-item-col">{{item.title}}</div>
                     </div>
                 </div>
             </div>
        </div>
        <van-popup v-model="showShare" position="bottom" :close-on-click-overlay="false" >
         <div class="sharebox">
               <div class="btngroup">
                    <div class="btngroup-col" @click="doCopy">
                         <div class="shareicon"><img src="~@/assets/img/share4-1.png"/></div>
                         <div class="sharewords">复制优惠码</div>
                    </div>
                    <div class="btngroup-col" @click="doShare(1)">
                       <div class="shareicon"><img src="~@/assets/img/share4-2.png"/></div>
                       <div class="sharewords">微信朋友圈</div>
                  </div>
                  <div class="btngroup-col"  @click="doShare(2)">
                       <div class="shareicon"><img src="~@/assets/img/share4-3.png"/></div>
                       <div class="sharewords">微信好友</div>
                  </div>
                  <div class="btngroup-col" @click="doSavePic">
                       <div class="shareicon"><img src="~@/assets/img/share4-4.png"/></div>
                       <div class="sharewords">保存图片</div>
                  </div>
               </div>
               <div class="cancelbtn" @click="closeShare">取 消</div>
         </div>  
     </van-popup> 
     <ShareImg v-if='uinfo.headimg && showShare' :headimg='uinfo.headimg' :qrcode='uinfo.sharecode' :username='uinfo.username' :mobile='uinfo.mobile'/>
     <van-overlay :show="showTipImg" @click="showTipImg = false">
        <div @click.stop>
          <div class="tip-block">
              <img src="~@/assets/img/sharetip.png" class="tip-block-img"/>
          </div>
        </div>
     </van-overlay>
  </div>
</template>
<script>
import Icon from "@/components/icon"
import ShareImg from '@/components/shareimg'
import { Swipe,SwipeItem,Popup,Overlay} from 'vant';

export default {
   name: 'index',
   data() {
      return {
         uinfo:{headimg:''},
         showShare:false,
         showTipImg:false,
         lunbolist:[],
         windowshow:[],
         iswindowsshowed:false,
         activities:[]
      }
   }, 
   created(){
      this.$store.commit('INIT_CART')
      this.$store.commit('INIT_ADDRESS') 
      this.getList(); 
   },
   methods: {
      getList(){
          this.$post("/index/getIndex",{}).then((data)=>{
            if(!data.result.success){
              this.$toast(data.result.info);return false
            }
            this.uinfo     =data.result.info.uinfo
            this.lunbolist =data.result.info.lunbolist
            this.windowshow=data.result.info.windowshow
            this.iswindowsshowed=data.result.info.iswindowsshowed
            this.activities=data.result.info.activities
            this.$store.commit('SET_FAHUONUMS',{fahuonums:data.result.info.fahuonums})
          })
      },
      goPage(url){
         this.$go(url)
      },
      popShareSheet(){
         this.showShare=true
      },
      closeShare(){
         this.showShare=false  
      },
      showTips(){
         this.$toast("请下载蓉畅生物科技App后再操作")  
      },
      doCopy(){
          this.$copyText(this.uinfo.idcode.toString()).then(function () {
          }, function () {
          })
          this.showShare=false
          this.$toast("复制成功")
      },
      doSavePic(){
         this.showShare=false  
         this.$toast("请使用手机截屏保存图片")  
      },
      doShare(type){
           this.$post("/user/initWxShare",{url:location.href.split('#')[0]}).then((data)=>{
               if(data.result.info.iswx==1){
                    var wx = require('weixin-js-sdk');
                    const signPac=data.result.info.signPackage
                    wx.config({
                         appId: signPac.appId, 
                         timestamp: signPac.timestamp.toString(), 
                         nonceStr: signPac.nonceStr.toString(), 
                         signature: signPac.signature,
                         jsApiList: ['updateAppMessageShareData','updateTimelineShareData'] 
                    });
               
                    const share=data.result.info.share
                    if(type==2){
                         wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                              wx.updateAppMessageShareData({ 
                              title: share.title, 
                              desc: share.desc, 
                              link: share.link, 
                              imgUrl: share.imgUrl, 
                              success: function () {
                              }
                       })
                      });
                    }else if(type==1){
                         wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
                              wx.updateTimelineShareData({ 
                              title: share.title, 
                              link: share.link, 
                              imgUrl: share.imgUrl, 
                              success: function () {
                              }
                              })
                          });
                    }
                    this.showShare=false 
                    this.showTipImg=true 
               }else{
                    this.showShare=false 
                    this.$toast("请在微信中打开分享")
               }
           })
      }
   },
   components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Popup.name]: Popup,
      [Overlay.name]: Overlay,
      Icon,
      ShareImg
   }
}
</script>
<style scoped>
#index{background-color:#F6F6F6;min-height: 100vh;}
.topcon{position: fixed;left:0;top:0;width:100%;height:1.4rem;color:#fff;padding: 0.3rem;display: flex;align-items: center;z-index:999;background-color:#fff;}
.topcon-headimg{margin-right: 0.3rem;}
.topcon-headimg img{width:100%;border-radius: 0.1rem;width:1.0rem;height:1.0rem;}
.topcon-user-group{display: flex;flex-direction: column;justify-content: center;align-items: flex-start;}
.topcon-user-name{color:#333;}
.topcon-user-level{margin-top:0.1rem;display: flex;align-items: center;color:#444}
.topcon-user-level-style{width:0.35rem;height:0.35rem;}
.topcon-right{margin-left:auto;display: flex;flex-flow: row nowrap;}
.topcon-right-share{margin-right:0.2rem;}
.maincon{width:100%;margin-top:1.5rem;padding: 0 0.25rem;padding-bottom: 60px;}

.maincon-levelup{border-radius: 0.1rem;display: flex;height:1.5rem;padding: 0.1rem;align-items: center;background-color:#F4C68A;}
.maincon-levelup-col1-img{width:1rem;height:1rem;padding: 0.1rem;}
.maincon-levelup-col2{display: flex;flex-flow: column nowrap;margin-left: 0.2rem;}
.maincon-levelup-col2-text1{color:#666;font-size:0.3rem;text-align: left;}
.maincon-levelup-col2-text2{color:#333;font-size: 0.35rem;text-align: left;}
.maincon-levelup-right{padding: 0.2rem;margin-left: auto;font-size: 0.35rem;color:#333;}

.maincon-swipelist{margin-top: 0.2rem;}
.my-swipe{color: #2d2c32;text-align: center;}
.maincon-swipe-img{margin: 0;padding: 0;width:100%;border-radius: 0.1rem;}
.maincon-btngroup{display: flex;flex-flow: column nowrap;margin-top:0.2rem;border-radius: 0.1rem;background-color: #fff;padding-bottom: 0.5rem;}
.maincon-btngroup-con{display: flex;flex-flow: row nowrap;}
.maincon-btngroup-title{color:#333;padding:0.4rem;text-align: left;font-size: 0.3rem;}
.maincon-btnitem{display: flex;flex-flow: column nowrap;flex:0 0 25%}
.maincon-btnitem-img img{width:1rem;height:1rem;}
.maincon-btnitem-text{color:#333;margin-top: 0.1rem;font-size:0.35rem;}
.actcon{border-radius: 0.1rem;width: 100%;margin-top: 0.25rem;background-color: #fff;}
.actcon-title{color:#333;text-align: left;padding: 0.4rem 0.4rem 0 0.4rem;font-size: 0.3rem;}
.actcon-list{margin-top: 0.05rem}
.actcon-list-item-row{margin-top: 0.1rem;padding: 0.1rem;display: flex;flex-flow: row nowrap;}
.actcon-list-item-col{flex:0 0 50%;padding: 0.2rem;color:#333;text-align: left;font-size:0.35rem;}
.actcon-list-item-col img{border-radius: 0.1rem;height:2.5rem;}
.iconstyle{width:0.6rem;height:0.6rem}

.sharebox{border-top-left-radius: 0.2rem;border-top-right-radius: 0.2rem;display: flex;width:100%;background-color: #fff;flex-flow: column nowrap;}
.btngroup{display: flex;padding-bottom: 0.35rem;height:3rem;align-items: center;}
.btngroup-col{display: flex;flex-flow: column nowrap;flex:0 0 25%;}
.shareicon{padding: 0.58rem;padding-bottom: 0.2rem;}
.shareicon img{width:100%;}
.sharewords{font-size: 0.25rem;color:#333;}
.cancelbtn{background-color: #f0f0f0;color:#999999;font-size: 0.3rem;display: flex;height: 1rem;justify-content: center;align-items: center;}
.sharebarcode{display: flex;position: absolute;width:100%;height: calc( 100vh - 4rem );z-index:9999;align-items: center;justify-content: center;background-color: transparent;left:0;top:0;}
.sharebarcode-img{width:6.5rem;background-color: #fff;border-radius: 0.25rem;display: flex;align-items: center;justify-content: center;flex-flow: column nowrap;padding: 0.6rem;}
.sharetip{padding: 0.15rem;user-select: none;}
.tip-block{display: flex;justify-content: flex-end;width: 100%;}
.tip-block-img{width:320px;height:256px;}
::v-deep .van-overlay {z-index:1000;}
.windowgroup{display: flex;flex-flow: column nowrap;margin-top:0.2rem;}
.part1{width:100%;}
.part2{width:100%;display: flex;flex-flow: row nowrap;}
.part2-left{width:50%;}
.part2-right{width:50%;padding-left: 0.05rem;display: flex;flex-flow: column nowrap;justify-content: space-between;}
</style>